export const width = 136;
export const height = 113;
export default __webpack_public_path__ + "static/finance-rafiki-3.5b6e00fc.svg";